import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["textContent"]
const _hoisted_2 = {
  key: 2,
  class: "font-bold",
  textContent: ' / '
}

import { computed, toRefs } from 'vue';
import { OrganizationInterface } from '@/types';

interface OrganizationPropsInterface {
  organizations?: OrganizationInterface[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OrganizationConnections',
  props: {
    organizations: {}
  },
  setup(__props: any) {

const props = __props;

const { organizations } = toRefs(props);

const buildOrganizations = computed(() => {
  return total.value <= 3
    ? organizations.value
    : [
        organizations.value.at(0),
        {
          id: null,
          name: '...',
          children: [],
        },
        organizations.value.at(-1),
      ];
});

const tooltip = computed<string>(() => organizations.value.map((item) => item.name).join(' / '));

const total = computed<number>(() => organizations.value.length);

const groupBy = (data, property) => {
  return data
    .reduce((acc, obj) => {
      const key = obj[property];

      if (!acc[key]) acc[key] = [];
      acc[key].push(obj.name);
      return acc;
    }, [])
    .filter(Boolean);
};

const showSeparator: boolean = (key) => buildOrganizations.value.length !== key + 1;

const showSubTag: boolean = (item, key) => buildOrganizations.value.length - 1 === key && item.children.length;

const subTag: string = () => {
  const last = buildOrganizations.value.length - 1;
  const items = buildOrganizations.value[last].children;
  const children = groupBy(items, 'parent_id');
  const list = children.map((item) => `<li>${item.join(' / ')}</li>`).join('');

  return `<ul>${list}</ul>`;
};

const subTagTotal: string = (item) => `${item.children.length} Sub-organizations`;

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Tag = _resolveComponent("Tag")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buildOrganizations.value, (item, key) => {
    return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
      (!!item.id)
        ? (_openBlock(), _createBlock(_component_RouterLink, {
            key: 0,
            to: `/organizations/${item.id}`,
            class: "font-semibold",
            textContent: _toDisplayString(item.name)
          }, null, 8, ["to", "textContent"]))
        : _withDirectives((_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "text-teal-600 font-bold cursor-pointer",
            textContent: _toDisplayString(item.name)
          }, null, 8, _hoisted_1)), [
            [
              _directive_tooltip,
              { value: tooltip.value, fitContent: false, class: 'custom-tooltip' },
              void 0,
              { bottom: true }
            ]
          ]),
      (showSeparator(key))
        ? (_openBlock(), _createElementBlock("span", _hoisted_2))
        : _createCommentVNode("", true),
      (showSubTag(item, key))
        ? _withDirectives((_openBlock(), _createBlock(_component_Tag, {
            key: 3,
            value: subTagTotal(item),
            class: "ml-3 bg-gray-light font-normal cursor-pointer"
          }, null, 8, ["value"])), [
            [
              _directive_tooltip,
              {
        value: subTag(item),
        escape: true,
        fitContent: false,
        class: 'custom-tooltip',
      },
              void 0,
              { bottom: true }
            ]
          ])
        : _createCommentVNode("", true)
    ], 64))
  }), 128))
}
}

})